import { AppStatic } from '../_helpers/app-static'

import { BaseClass } from './_base.model'

export class Message extends BaseClass {
  klass = 'Message'
  
  name: string
  email: string
  body: string
  message_type: string
  status: string

}
